export const featuredPhotosX3PromoPath = '/promo/featured-photos-x3'
